import {
    AWT_NEAR_REAL_TIME,
    AWTLogManager,
    AWTEventData,
    AWTEventProperty,
    AWTEventPriority,
    AWT_COLLECTOR_URL_EUROPE,
    AWT_COLLECTOR_URL_USGOV_DOJ,
    AWT_COLLECTOR_URL_USGOV_DOD,
    AWTLogger,
} from '@aria/webjs-sdk';
import { getPhysicalRing } from 'owa-config';

export function initializeLogManager(tenantTokens: string) {
    AWTLogManager.setTransmitProfile(AWT_NEAR_REAL_TIME);

    const collectorUri = getCollectorUrl();
    if (collectorUri) {
        AWTLogManager.initialize(tenantTokens, { collectorUri });
    } else {
        AWTLogManager.initialize(tenantTokens);
    }

    return AWTLogManager.getSemanticContext();
}

export function getLogger(tenantToken: string): AWTLogger {
    return AWTLogManager.getLogger(tenantToken);
}

export function createEventProperties(eventName?: string): AWTEventData {
    return {
        name: eventName,
        properties: {},
    };
}

export function createSessionDatapoint(properties: {
    [key: string]: string | number | boolean | AWTEventProperty;
}): AWTEventData {
    let sessionEvent: AWTEventData = {
        name: 'session',
        type: 'session',
        properties,
    };
    sessionEvent.priority = AWTEventPriority.High;
    return sessionEvent;
}

export function ariaFlush() {
    AWTLogManager.flush(() => {});
}

function getCollectorUrl(): string {
    const environment = getPhysicalRing();
    switch (environment) {
        case 'BlackForest':
            return AWT_COLLECTOR_URL_EUROPE;
        case 'GccHigh':
            return AWT_COLLECTOR_URL_USGOV_DOJ;
        case 'DoD':
            return AWT_COLLECTOR_URL_USGOV_DOD;
        default:
            return undefined;
    }
}
